export default __webpack_public_path__ + "static/media/error.12b28620.png";